import type { Feature } from '@luna/gatekeeper';

export const topUp: Feature = {
    enabled: true,
    _description: 'Enables top up focus page',
};
